<template>
    <div class="themeBgList">
        <div class="bg-item" v-for="(item, index) in bgImgList" :key="index" @click="setThemeBg(item)">
            <div :class="{'img_box':true, 'current': item.isSetBackground==1}">
                <!-- 已设置标识 -->
                <div class="set-tag" v-if="item.isSetBackground==1">已设置</div>
                <!-- 鼠标悬停提示 -->
                <div class="hover-tip">点击设置背景图</div>
                <img :src="item.backgroundImage" />
            </div>
            <p>{{ item.backgroundTitle }}</p>
        </div>
    </div>
</template>

<script>
import { getUserInfo } from "@/common/utils/localStorage.js";
import { bgImgList, updateBgImg } from "../api/user.js";//查询书架数据
export default {
    data(){
        return {
            bgImgList:[]
        }
    },
    mounted(){
        this.getBgImgList();
    },
    methods:{
        getBgImgList(){
            let vm = this;
            bgImgList({
                orgId: getUserInfo().orgId,
                visitType: 2,
                visitUrl: location.href,
                visitFunc: "",
            }).then(res => {
                if(res.status){
                    vm.bgImgList = res.data.list;
                }
            }).catch(err => {

            });
        },
        setThemeBg(item){
            let vm = this;
            vm.$confirm('您确定设置这个为主题背景吗？', '提示', {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                // 先将所有背景图的已设置状态改为0
                vm.bgImgList.forEach(img => {
                    img.isSetBackground = 0;
                });
                // 设置当前选中项为已设置
                item.isSetBackground = 1;            
                updateBgImg({
                    pkid: item.pkid,
                    orgId: getUserInfo().orgId,
                    isSetBackground: 1,
                    visitType: 2,
                    visitUrl: location.href,
                    visitFunc: "",
                }).then(res => {
                    if(res.status){
                        vm.$emit('submit');//设置背景
                    }
                    vm.getBgImgList();
                }).catch(err => {
                    vm.getBgImgList();
                });
            }).catch(() => {

            });
        }
    }
}
</script>
<style lang="scss">
.themeBgList{
    display: flex;
    flex-wrap: wrap;
    .bg-item{
        margin: 10px;
        box-sizing: border-box;
        text-align: center;
        width: 240px;
        cursor: pointer;
        
        .img_box{
            position: relative; /* 相对定位，用于子元素绝对定位 */
            display: flex;
            width: 240px;
            height: 80px;
            justify-content: center;
            align-items: center;
            border:1px solid #e0e0e0;
            border-radius: 10px;
            overflow: hidden; /* 隐藏超出容器的内容 */
            transition: all 0.3s ease; /* 过渡动画 */
            
            &:hover{
                border-color: #17a06b;
                box-shadow: 0 2px 8px rgba(0,0,0,0.1);
            }
            
            &.current{
                border:1px solid #17a06b;
            }
        }
        
        img{
            max-width: 100%;
            max-height: 100%;
            transition: all 0.3s ease; /* 图片过渡效果 */
        }
        
        // 已设置标签样式
        .set-tag{
            position: absolute;
            top: 5px;
            right: 5px;
            background-color: #17a06b;
            color: white;
            font-size: 12px;
            padding: 2px 8px;
            border-radius: 4px;
            z-index: 2; /* 确保在图片上方 */
        }
        
        // 悬停提示样式
        .hover-tip{
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0,0,0,0.6);
            color: white;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 14px;
            opacity: 0; /* 默认隐藏 */
            transition: opacity 0.3s ease; /* 过渡动画 */
            z-index: 1; /* 确保在图片上方，但在已设置标签下方 */
        }
        
        .img_box:hover .hover-tip{
            opacity: 1; /* 鼠标悬停时显示 */
        }
        
        .img_box:hover img{
            transform: scale(1.05); /* 鼠标悬停时图片轻微放大 */
        }
    }
}
</style>
    


// WEBPACK FOOTER //
// src/components/themeBgList.vue